/* index.tsx generated by @compiled/babel-plugin v3.0.2 */
import { ax, ix } from "@compiled/react/runtime";
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._3vBAKH9r67%7Bborder-color%3Avar(--ds-border%2C%230b120e24)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0LQT5ENHnM%7Bpadding-inline-start%3Avar(--ds-space-300%2C24px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._03SyCPNHnM%7Bpadding-inline-end%3Avar(--ds-space-300%2C24px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._46hvQm5zaO%7Bpadding-block-start%3Avar(--ds-space-200%2C1pc)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0xmtko5zaO%7Bpadding-block-end%3Avar(--ds-space-200%2C1pc)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._2yjt2x6wH8%7Bborder-block-end-style%3Asolid%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._4auqkJNvrM%7Bborder-block-end-width%3Avar(--ds-border-width%2C1px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0jFU0VmdCj%7Bheight%3A56px%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._2O5Vij7dHp%7Bflex-grow%3A1%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._2mHwu82ADO%7Bgap%3Avar(--ds-space-100%2C8px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._3iDTPbQ4SZ%7Bdisplay%3Aflex%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0aFT5v1qpb%7Bflex-direction%3Arow%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0hPCNLDIqT%7Balign-items%3Acenter%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._37wbyuI7V3%7Bjustify-content%3Aspace-between%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._4ouGXIdnbC%7Bmin-width%3A0%7D");
import React from 'react';
import useCrossProductUrlWrapper from '@atlassiansox/analytics-cross-product-interaction-client/use-cross-product-url-wrapper';
import { useIntl } from 'react-intl';
import IconButton from '@atlaskit/button/icon/button';
import ArrowLeft from '@atlaskit/icon/core/arrow-left';
import CrossIcon from '@atlaskit/icon/core/cross';
import LinkExternalIcon from '@atlaskit/icon/core/link-external';
import { fg } from '@atlaskit/platform-feature-flags/fg';
import { Box, Flex, Inline } from '@atlaskit/primitives/compiled';
import { PanelAction, PanelActionClose, PanelActionGroup, PanelHeader } from '@atlassian/panel-system';
import messages from '../../common/messages';
import { PreviewPanelNewTabLink } from '../preview-panel-action-variants/preview-panel-new-tab-link';
import type { PreviewPanelHeaderProps } from './types';

/**
 * Removes the specified query parameter from a URL while preserving all other parameters
 * @param url - The original URL
 * @param paramToRemove - The query parameter name to remove
 * @returns The URL with the specified parameter removed
 *
 * @private
 * @deprecated `@atlassian/preview-panel` is deprecated. Use `@atlassian/panel-system` instead.
 * {@link https://atlassian.design/components/panel-system/examples}
 */
export const removeQueryParam = (url: string, paramToRemove: string): string => {
  try {
    const urlObj = new URL(url);
    urlObj.searchParams.delete(paramToRemove);
    return urlObj.toString();
  } catch {
    // If URL parsing fails, return the original URL
    return url;
  }
};
const styles = {
  header: "_3vBAKH9r67 _0LQT5ENHnM _03SyCPNHnM _46hvQm5zaO _0xmtko5zaO _2yjt2x6wH8 _4auqkJNvrM _0jFU0VmdCj",
  childWrapper: "_2O5Vij7dHp",
  titleRegion: "_2mHwu82ADO _3iDTPbQ4SZ _0aFT5v1qpb _0hPCNLDIqT _37wbyuI7V3 _2O5Vij7dHp _4ouGXIdnbC"
};

/**
 * @private
 * @deprecated `@atlassian/preview-panel` is deprecated. Use `@atlassian/panel-system` instead.
 * {@link https://atlassian.design/components/panel-system/examples}
 */
export const PreviewPanelHeader = ({
  children,
  onClose,
  onOpenInNewTab,
  onNavigateBack,
  testId,
  url,
  analyticsClient,
  parentProduct,
  panelType,
  moreActions
}: PreviewPanelHeaderProps): React.JSX.Element => {
  const {
    formatMessage
  } = useIntl();
  const enableCrossMAUUsage = fg('platform_preview_panels_cross_app_interaction');
  const buildUrlWithAnalyticsParams = useCrossProductUrlWrapper({
    bridge: 'preview-panels',
    product: parentProduct ?? 'unknown'
  });
  const onPanelClose = () => {
    analyticsClient?.sendTrackEvent({
      action: 'clicked',
      actionSubject: 'button',
      actionSubjectId: 'preview-panel-close',
      source: 'preview-panel',
      attributes: {
        parentProduct,
        panelType
      }
    });
    onClose?.();
  };
  const onOpenInNewWindow = () => {
    analyticsClient?.sendTrackEvent({
      action: 'clicked',
      actionSubject: 'link',
      actionSubjectId: 'preview-panel-open-in-new-window',
      source: 'preview-panel',
      attributes: {
        parentProduct,
        panelType
      }
    });
    onOpenInNewTab?.();
    if (url) {
      window.open(enableCrossMAUUsage ? buildUrlWithAnalyticsParams(removeQueryParam(url, 'previewPanels')) : removeQueryParam(url, 'previewPanels'));
    }
  };
  const onPanelNavigateBack = () => {
    analyticsClient?.sendTrackEvent({
      action: 'clicked',
      actionSubject: 'button',
      actionSubjectId: 'preview-panel-navigate-back',
      source: 'preview-panel',
      attributes: {
        parentProduct,
        panelType
      }
    });
    onNavigateBack?.();
  };
  if (fg('ads-panel-system-gpp')) {
    return <PanelHeader testId={testId}>
				{onNavigateBack && fg('jivtech-1920-back-navigation-gpp') && <PanelAction icon={ArrowLeft} label={formatMessage(messages.previewPanelNavigateBackLabel)} onClick={onPanelNavigateBack} testId={testId && `${testId}.navigate-back-button`} appearance="default" />}
				<Box xcss={styles.titleRegion}>{children}</Box>
				<PanelActionGroup>
					{url && <PanelAction icon={LinkExternalIcon} label={formatMessage(messages.previewPanelOpenInNewWindowLabel)} onClick={onOpenInNewWindow} testId={testId && `${testId}.open-in-new-window-button`} appearance="subtle" />}
					{moreActions}
					{onClose && <PanelActionClose onClick={onPanelClose} testId={testId && `${testId}.close-button`} label={formatMessage(messages.previewPanelCloseButtonLabel)} />}
				</PanelActionGroup>
			</PanelHeader>;
  }
  return <Inline xcss={styles.header} testId={testId} alignBlock="center" space="space.100">
			{onNavigateBack && fg('jivtech-1920-back-navigation-gpp') && <IconButton icon={iconProps => <ArrowLeft {...iconProps} size="small" />} label={formatMessage(messages.previewPanelNavigateBackLabel)} onClick={onPanelNavigateBack} testId={testId && `${testId}.navigate-back-button`} />}
			<Inline xcss={styles.childWrapper} spread="space-between" alignBlock="center" space="space.100">
				{children}
			</Inline>
			<Flex gap="space.100">
				{url && <PreviewPanelNewTabLink label={formatMessage(messages.previewPanelOpenInNewWindowLabel)} onClick={onOpenInNewWindow} testId={testId && `${testId}.open-in-new-window-button`} />}
				{moreActions}
				{onClose && <IconButton icon={iconProps => <CrossIcon {...iconProps} size="small" />} label={formatMessage(messages.previewPanelCloseButtonLabel)} onClick={onPanelClose} testId={testId && `${testId}.close-button`} role="button" />}
			</Flex>
		</Inline>;
};